import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Grid, IconButton, makeStyles, Tooltip, Typography } from "@material-ui/core";
import { GetApp, DeleteSweepRounded } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => ({
  fontSize13: { fontSize: "13px" },
  padding8: { padding: "8px" },
}));

function DownloadOrDeleteDocument({ index, file, onDownloadFile, onDeleteFile, disabled }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleDeleteFile = useCallback(() => {
    onDeleteFile(file.sharePointUID, index);
  }, [file, index, onDeleteFile]);

  const handleDownloadFile = useCallback(() => {
    onDownloadFile(file.sharePointUID, file.fileName);
  }, [file, onDownloadFile]);

  return (
    <Grid container alignItems="center" justifyContent="center">
      <Grid item xs={10}>
        <Typography className={classes.fontSize13}>{file.fileName}</Typography>
      </Grid>
      <Grid item xs={2} container alignItems="center" justifyContent="flex-end">
        <IconButton disabled={false} onClick={handleDownloadFile} className={classes.padding8}>
          <Tooltip title={t("General.DownloadFile")} placement="top">
            <GetApp color="action" fontSize="small" />
          </Tooltip>
        </IconButton>
        <IconButton disabled={disabled} onClick={handleDeleteFile} className={classes.padding8}>
          <Tooltip title={t("General.DeleteFile")} placement="top">
            <DeleteSweepRounded fontSize="small" />
          </Tooltip>
        </IconButton>
      </Grid>
    </Grid>
  );
}

DownloadOrDeleteDocument.propTypes = {
  index: PropTypes.number.isRequired,
  file: PropTypes.object.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
  onDeleteFile: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DownloadOrDeleteDocument;
